<div class="flex flex-col w-full rounded-md">
    <!-- Header -->
    <p>
        <mat-toolbar class="bg-primary">
            <mat-toolbar-row>
                @if(color() === 'success') {
                <span class="text-white font-semibold"
                    >¡Operación exitosa!</span
                >
                } @if(color() === 'info') {
                <span class="text-white font-semibold">¡Importante!</span>
                } @if(color() === 'warning') {
                <span class="text-white font-semibold">¡Advetencia!</span>
                } @if(color() === 'error') {
                <span class="text-white font-semibold">¡Lo sentimos!</span>
                }
                <span class="flex-auto"></span>
                <a mat-icon-button [matTooltip]="'Close'" (click)="close(true)">
                    <mat-icon class="text-white">close</mat-icon>
                </a>
            </mat-toolbar-row>
        </mat-toolbar>
    </p>

    <div class="relative flex flex-col flex-auto items-start p-6 sm:p-12">
        <div class="w-full max-w-lg flex flex-col items-center gap-3">
            @switch (color()) { @case ("success") {
            <mat-icon
                class="icon-size-20"
                [ngClass]="iconClass() ?? 'text-success'"
                >check_circle</mat-icon
            >
            } @case ("info") {
            <mat-icon
                class="icon-size-20"
                [ngClass]="iconClass() ?? 'text-info'"
                >info</mat-icon
            >
            } @case ("warning") {
            <mat-icon
                class="icon-size-20"
                [ngClass]="iconClass() ?? 'text-warn'"
                >report_problem</mat-icon
            >
            } @case ("error") {
            <mat-icon
                class="icon-size-20"
                [ngClass]="iconClass() ?? 'text-warn'"
                >highlight_off</mat-icon
            >
            } }

            <h4 class="text-center">{{ message() }}</h4>
            @if (multiline(); as lines) { @if (lines.length) { @for (item of
            lines; track $index) {
            <p class="text-center w-full">{{ item }}</p>
            } } }
        </div>
    </div>

    <!-- Actions -->
    <div
        class="flex items-center justify-center px-6 sm:px-12 py-4 border-t bg-gray-50 dark:bg-transparent"
    >
        <button
            mat-flat-button
            [color]="'primary'"
            [matTooltip]="'OK'"
            (click)="close({ data: true })"
        >
            OK
        </button>
    </div>
</div>
